import { useState, useEffect } from 'react'
import { PackageService } from '../services/packageService'
import { PackageType } from '../config/api'

export const usePackageTypes = () => {
  const [packageTypes, setPackageTypes] = useState<PackageType[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchPackageTypes = async () => {
      try {
        setLoading(true)
        const service = PackageService.getInstance()
        const types = await service.getPackageTypes()
        setPackageTypes(types)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch package types')
      } finally {
        setLoading(false)
      }
    }

    fetchPackageTypes()
  }, [])

  return { packageTypes, loading, error }
}
